import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpRequest,
  HttpHandler,
  HttpClient,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as env } from '@env/environment';
import { InvestigationService } from '@app/shared/store/investigation.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private inves: InvestigationService, private http: HttpClient) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const globalToken = sessionStorage.getItem('GlobalToken');
    if (!globalToken) {
      return next.handle(req);
    }

    if (!req.url.includes('investigations')) {
      return next.handle(req);
    }

    const req1 = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${globalToken}`),
    });

    if (req.url.includes('investigations') && !req.url.includes('finalize')) {
      if (
        req.method === 'POST' ||
        req.method === 'PUT' ||
        req.method === 'DELETE'
      ) {
        if (this.inves?.InvestigationID) {
          this.http
            .get(
              `${env.api}/investigations/${this.inves.InvestigationID}/updatedetails`
            )
            .toPromise();
        }
      }
    }

    return next.handle(req1);
  }
}
